import apiClient from './index';

export type WebNotification = {
  id: string;
  type: string;
  title: string;
  body: string;
  url?: string | null;
  read_at?: string | null;
  created_at: string;
};

export const webPushApi = {
  getConfig: async () => (await apiClient.get('/web-push/config')).data,
  subscribe: async (subscription: PushSubscription) => {
    const json = subscription.toJSON();
    return (await apiClient.post('/web-push/subscriptions', {
      endpoint: subscription.endpoint,
      keys: json.keys,
      content_encoding: 'aes128gcm',
    })).data;
  },
  unsubscribe: async (endpoint: string) => (
    await apiClient.delete('/web-push/subscriptions', { data: { endpoint } })
  ).data,
  list: async () => (await apiClient.get('/web-push/notifications', {
    params: { limit: 20 },
  })).data,
  markRead: async (id: string) => apiClient.post(`/web-push/notifications/${id}/read`),
  markAllRead: async () => apiClient.post('/web-push/notifications/read-all'),
  sendTest: async () => apiClient.post('/web-push/test'),
};
